import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logger } from 'shared/utils/logger';
import { User, UserListItem, UsersStateType } from '../types/types';
import {
  getUsers, getUserById, createUser, updateUser, updateUserStatus, deleteUser,
} from '../actions/actions';

const initialState: UsersStateType = {
  userDetail: {
    isLoading: false,
    data: null,
  },
  users: [],
  isLoading: false,
};

const slice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    dropDetailData(state: UsersStateType) {
      state.userDetail.data = null;
    },
  },
  extraReducers(builder) {
    builder.addCase(getUsers.pending, (state: UsersStateType) => {
      state.isLoading = true;
    });
    builder.addCase(getUsers.fulfilled, (state: UsersStateType, action: PayloadAction<UserListItem[]>) => {
      state.users = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getUsers.rejected, (state: UsersStateType, action) => {
      logger.error('users/getUsers', action.payload);
      state.isLoading = false;
    });

    builder.addCase(getUserById.pending, (state: UsersStateType) => {
      state.userDetail.isLoading = true;
    });
    builder.addCase(getUserById.fulfilled, (state: UsersStateType, action: PayloadAction<User>) => {
      state.userDetail.data = action.payload;
      state.userDetail.isLoading = false;
    });
    builder.addCase(getUserById.rejected, (state: UsersStateType, action) => {
      logger.error('users/getUserById', action.payload);
      state.userDetail.isLoading = false;
    });

    // Удалены несуществующие case'ы

    builder.addCase(createUser.pending, (state: UsersStateType) => {
      state.userDetail.isLoading = true;
      state.isLoading = true;
    });
    builder.addCase(createUser.fulfilled, (state: UsersStateType) => {
      state.userDetail.isLoading = false;
      state.isLoading = false;
    });
    builder.addCase(createUser.rejected, (state: UsersStateType, action) => {
      logger.error('users/createUser', action.payload);
      state.userDetail.isLoading = false;
      state.isLoading = false;
    });

    builder.addCase(updateUser.pending, (state: UsersStateType) => {
      state.userDetail.isLoading = true;
      state.isLoading = true;
    });
    builder.addCase(updateUser.fulfilled, (state: UsersStateType) => {
      state.userDetail.isLoading = false;
      state.isLoading = false;
    });
    builder.addCase(updateUser.rejected, (state: UsersStateType, action) => {
      logger.error('users/updateUser', action.payload);
      state.userDetail.isLoading = false;
      state.isLoading = false;
    });

    builder.addCase(updateUserStatus.pending, (state: UsersStateType) => {
      state.userDetail.isLoading = true;
      state.isLoading = true;
    });
    builder.addCase(updateUserStatus.fulfilled, (state: UsersStateType) => {
      state.userDetail.isLoading = false;
      state.isLoading = false;
    });
    builder.addCase(updateUserStatus.rejected, (state: UsersStateType, action) => {
      logger.error('users/updateUserStatus', action.payload);
      state.userDetail.isLoading = false;
      state.isLoading = false;
    });

    builder.addCase(deleteUser.pending, (state: UsersStateType) => {
      state.isLoading = true;
    });
    builder.addCase(deleteUser.fulfilled, (state: UsersStateType, action: PayloadAction<number>) => {
      state.users = state.users.filter((user) => user.id !== action.payload);
      state.isLoading = false;
    });
    builder.addCase(deleteUser.rejected, (state: UsersStateType, action) => {
      logger.error('users/deleteUser', action.payload);
      state.isLoading = false;
    });
  },
});

export const usersActions = slice.actions;
export default slice.reducer;
